import script from "./ReceitasRecebidasVencimento.vue?vue&type=script&setup=true&lang=js"
export * from "./ReceitasRecebidasVencimento.vue?vue&type=script&setup=true&lang=js"

import "./ReceitasRecebidasVencimento.vue?vue&type=style&index=0&id=ad8b1c56&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad8b1c56"]])

export default __exports__